import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';

import { NavigationItem } from './navigation-item';
import { SidebarHeader } from './sidebar-header';
import { SidebarFooter } from './sidebar-footer';
import type { NavigationItemWithState } from '@/entities/navigation';
import type { User } from '@/entities/layout';

interface MobileSidebarProps {
  user?: User;
  projectName: string;
  siteName: string;
  instanceName: string;
  isCluster: boolean;
  items: NavigationItemWithState[];
  isOpen: boolean;
  onToggleItem: (code: string) => void;
  onClose: () => void;
}

export const MobileSidebar = ({
  user,
  projectName,
  siteName,
  instanceName,
  isCluster,
  items,
  isOpen,
  onToggleItem,
  onClose
}: MobileSidebarProps) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <aside className="fixed inset-y-0 left-0 z-50 w-full flex flex-col h-screen bg-background border-r">
      <SidebarHeader
        projectName={projectName}
        siteName={siteName}
        instanceName={instanceName}
        isCluster={isCluster}
        isMobile={true}
        closeSidebar={onClose}
      />

      <div className="flex-1 overflow-y-auto py-4 custom-scrollbar">
        <div className="mb-6 px-3">
          <h3 className="text-xs font-medium text-muted-foreground mb-2 px-2 flex items-center justify-between group cursor-pointer">
            {t('sidebar.menu')}
            <ChevronDown className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
          </h3>
          <ul className="space-y-1">
            {items.map((item) => (
              <li key={item.code}>
                <NavigationItem item={item} isCollapsed={false} onToggle={onToggleItem} />
              </li>
            ))}
          </ul>
        </div>
      </div>

      {user && <SidebarFooter user={user} isCollapsed={false} />}
    </aside>
  );
};
